// @flow @jsx h
/* eslint-disable jsx-a11y/aria-role */
import { Component, h } from 'preact'

import styles from './index.css'

type Props = {
  fornavn: string,
  viewport: { height: number }
}

export class Header extends Component<Props> {
  render () {
    const { fornavn } = this.props

    return <div class={styles.header}>

      <div class={styles.header__content}>
        <h1 role='text'>
          <div class={styles.header__navn}>{fornavn}</div>
          <div class={styles.header__stikktittelContainer}>
            <div class={styles.header__stikktittelLead} />
          </div>
          <div>
            <div class={styles.animated}><span class={styles.arrow__down} /></div>
          </div>
        </h1>

      </div>
    </div>
  }
}

/* <div className={styles.header__stikktittel}>{stikktittel}</div> */
